var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"item",staticClass:"vue-grid-item expand-transition-enter-active",class:_vm.classObj,style:(_vm.style)},[_vm._t("default"),(_vm.editMode)?_c('v-icon',{ref:"handle",staticClass:"vue-resizable-handle",attrs:{"color":"primary"}},[_vm._v("mdi-resize-bottom-right")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }